import React, {useEffect} from 'react'
export default function About(props){
    useEffect(() => {
        document.title = "About Mamma's Cafe"
    })
    return (
        <>
            <div className="container">
                
                <section className='section-intro'>
                    <h1 className="pic-text">
                        About Mamma's Café
                    </h1>
                    </section>
                
            </div>
            <div className="content">
                <h1>
                    Meet The Founder
                </h1>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur dolore, quod, eum hic quaerat alias blanditiis nihil amet ullam dolorem velit ipsum adipisci repellat? Magni eligendi distinctio neque repellendus officia dolorem, ipsum possimus quae voluptate delectus at cum sed? Quam blanditiis, libero a deserunt rem sint provident. Iste provident repudiandae omnis neque dolorum ab labore nesciunt corrupti, excepturi voluptates saepe recusandae natus officia! Quo, aperiam, voluptates magnam quibusdam eaque rem quia, ipsum placeat pariatur delectus ex? Molestias repellendus cum ad dolorem earum. Praesentium voluptatibus eos necessitatibus vitae! Quo quis eos temporibus molestias natus harum, porro sit sed placeat, corrupti fugit!

                <h1>
                    Meet Your Chef
                </h1>
                <span> Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis quisquam incidunt earum, repellat exercitationem soluta sequi aut quam vel eum. Quibusdam reprehenderit est quaerat alias temporibus nobis quae ipsum dolore?
                </span>
                
                <span> Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis quisquam incidunt earum, repellat exercitationem soluta sequi aut quam vel eum. Quibusdam reprehenderit est quaerat alias temporibus nobis quae ipsum dolore?
                </span>

            </div>
        </>
    )
}